// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2p1Ra","rootCenter":"LoadMoreObserver_rootCenter__EuiHG","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1pUNj"};